<template>
  <div class="select_dialog_embed">
    <div class="general_logistics_setup_embed_msg" :class="{'w_percent70': showType === 'add'}">
      <div class="select_dialog_embed_box">
        <!--弹出框头部-->
        <div class="select_dialog_embed_box_top">
          <p>{{title}}</p>
        </div>

        <!--弹出框信息-->
        <div v-if="showType === 'add'" class="select_dialog_embed_box_content add">
          <!--添加-->
          <div>
            <div class="inb mr20">
              <span><i class="fcDel">*</i>渠道：</span>
              <div class="inb">
                <el-select v-model="selectChannel" multiple collapse-tags placeholder="渠道">
                  <el-option
                    v-for="item in channelList"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="inb">
              <span><i class="fcDel">*</i>分类：</span>
              <div class="inb">
                <el-select v-model="selectClassificationType" multiple collapse-tags placeholder="分类">
                  <el-option
                    v-for="item in codeClassificationList"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div>
            <div class="inb mr20">
              <span><i class="fcDel">*</i>物流：</span>
              <div class="inb">
                <el-select v-model="selectCourierCompany" multiple collapse-tags placeholder="快递公司">
                  <el-option
                    v-for="item in courierCompanyList"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="inb">
              <span class="mr5">店铺售价</span>
              <span>≥</span>
              <div class="inb w84 ml5"><input type="text" placeholder="店铺售价" maxlength="20" v-model.number="shopPrice"></div>
            </div>
          </div>
          <div>
            <div class="inb mr20">
              <span><i class="fcDel">*</i>店铺：</span>
              <div class="inb">
                <el-select v-model="selectStore" multiple collapse-tags placeholder="店铺">
                  <el-option
                    v-for="item in storeList"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="province_select">
            <div class="inb mr10 vertical_center">
              <input type="checkbox" id="check_all" v-model="checkAll" @change="checkAllFun()"><label for="check_all">全选</label>
            </div>
            <div class="inb">
              <div class="province_list" v-for="(item, index) in areaProvincesList" :key="index">
                <span>{{item.regionName}}：</span>
                <ul>
                  <li v-for="itemProvince in item.provinceList">
                    <input type="checkbox" :id="itemProvince.provinceId" v-model="itemProvince.checked" @change="checkFun()">
                    <label :for="itemProvince.provinceId">{{itemProvince.provinceName}}</label>
                  </li>
                  <!--<li><input type="checkbox"><label>假的江苏省</label></li>-->
                  <!--<li><input type="checkbox"><label>假的广东省</label></li>-->
                </ul>
              </div>
            </div>
          </div>
          <div class="fcBlue">提示：如果有设置店铺售价，则订单货品成交价大于等于该设置价格时该规则才生效，没有设置店铺售价则该规则的生效不受订单货品的成交价影响。</div>
        </div>

        <!--删除-->
        <div v-if="showType === 'del'" class="select_dialog_embed_box_content text_center">
          <div class="mt20 mb20">
            是否删除当前选择项？
          </div>
        </div>

        <!--批量删除-->
        <div v-if="showType === 'batchDel'" class="select_dialog_embed_box_content text_center">
          <div class="mt20 mb20">
            是否批量删除当前选择的项？
          </div>
        </div>

        <!--弹出框底部-->
        <div class="select_dialog_embed_box_bottom pb30">
          <button class="btn_normal" @click="submitBtn()">确定</button>
          <button class="btn_cancel" @click="cancelBtn(false)">关闭</button>
        </div>
      </div>
    </div>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                @closebtn="closeMsgDialog"></msg-dialog>
  </div>
</template>

<script>
  import MsgDialog from '../../../public-component/msg-dialog';

  export default {
    name: 'general-logistics-setup-embed-msg',
    props: ['title', 'showType', 'msg'],
    components: {MsgDialog},
    data() {
      return {
        channelList: [], // 渠道下拉
        checkAll: false, // 全选
        // selectChannel: '', // 渠道选择
        selectChannel: [], // 渠道选择  2022.07.18 改传多选项
        codeClassificationList: [], // 查询分类下拉
        // selectClassificationType: '', // 选择的分类
        selectClassificationType: [], // 选择的分类 2022.07.18 改传多选项
        courierCompanyList: [], // 快递公司下拉
        // selectCourierCompany: '', // 选择的快递公司
        selectCourierCompany: [], // 选择的快递公司  2022.07.18 改传多选项
        storeList: [], // 店铺下拉
        // selectStore: '', // 店铺选择
        selectStore: [], // 店铺选择  2022.07.18 改传多选项
        shopPrice: null, // 店铺售价
        areaProvincesList: [], // 区域省份列表
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '' // 信息框内容
      }
    },
    methods: {
      // 获取店铺下拉框信息
      getAllPXShopList() {
        this.$axios.get(this.Global.getAllPXShopList).then((res) => {
          if (!res.data.errorMsg) {
            if (res.data.resData.length) {
              this.storeList = res.data.resData;
              this.selectStore = [];
              // this.selectStore = res.data.resData[0].id;
              // this.storeList.splice(this.storeList.findIndex(item => item.id === 0), 1);
            } else {
              this.storeList = res.data.resData;
              // this.selectStore = '';
              this.selectStore = [];
            }
            // this.storeList.splice(0, 0, {id: '', text: '所有店铺'});
          } else {
            this.storeList = [];
            // this.selectStore = res.data.errorMsg;
            this.selectStore = [];
          }
        });
      },

      // 获取渠道下拉框信息
      getAllStoreroomsList() {
        this.$axios.get(this.Global.getAllStoreroomsList).then((res) => {
          if (!res.data.errorMsg) {
            this.channelList = res.data.resData;
            // this.channelList.splice(0, 0, {id: '', text: '所有渠道'});
            // this.selectChannel = '';
            this.selectChannel = [];
          } else {
            this.channelList = [];
            // this.selectChannel = res.data.errorMsg;
            this.selectChannel = [];
          }
        });
      },

      // 加载分类下拉数据
      getAllClassList() {
        this.$axios.get(this.Global.getAllClassList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.codeClassificationList = res.data.resData;
            // this.codeClassificationList.splice(0, 0, {id: '', text: '所有分类'});
            // this.selectClassificationType = '';
            this.selectClassificationType = [];
          } else {
            this.codeClassificationList = [];
            // this.selectClassificationType = res.data.errorMsg;
            this.selectClassificationType = [];
          }
        });
      },

      // 获取快递公司下拉框
      getAllLogisticList() {
        this.$axios.get(this.Global.getAllLogisticList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.courierCompanyList = res.data.resData;
            // this.courierCompanyList.splice(0, 0, {id: '', text: '所有快递'});
            // this.selectCourierCompany = '';
            this.selectCourierCompany = [];
          } else {
            this.courierCompanyList = [];
            // this.selectCourierCompany = res.data.errorMsg;
            this.selectCourierCompany = [];
          }
        });
      },

      // 获取省份区域信息
      getRegionProvinceList() {
        this.$axios.get(this.Global.getRegionProvinceList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.areaProvincesList = res.data.resData;
            for (let i in this.areaProvincesList) {
              for (let y = 0; y < this.areaProvincesList[i].provinceList.length; y++) {
                this.$set(this.areaProvincesList[i].provinceList[y], 'checked', false);
              }
            }
          }
        });
      },

      // 全选
      checkAllFun() {
        for (let i in this.areaProvincesList) {
          for (let y in this.areaProvincesList[i].provinceList) {
            this.areaProvincesList[i].provinceList[y].checked = this.checkAll;
          }
        }
      },

      // 单选改变触发方法改变全选
      checkFun() {
        let flag = true;
        for (let i in this.areaProvincesList) {
          for (let y in this.areaProvincesList[i].provinceList) {
            if (!this.areaProvincesList[i].provinceList[y].checked) {
              flag = false;
            }
          }
        }
        this.checkAll = flag;
      },

      // 保存渠道配省份物流信息
      saveStoreroomProvinceLogisticInfo() {
        const checkProvince = [];
        for (let i in this.areaProvincesList) {
          for (let y = 0; y < this.areaProvincesList[i].provinceList.length; y++) {
            if (this.areaProvincesList[i].provinceList[y].checked) {
              checkProvince.push(this.areaProvincesList[i].provinceList[y].provinceId);
            }
          }
        }
        if (this.selectChannel.length < 1) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择一个渠道';
          return;
        } else if (this.selectClassificationType.length < 1) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择一种分类';
          return;
        } else if (this.selectCourierCompany.length < 1) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择一个物流公司';
          return;
        } else if (!checkProvince.length) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择至少一个省份';
          return;
        } else if (this.selectStore.length < 1) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择一个店铺';
          return;
        }
        const params = {
          id: 0,
          storeroomId: this.selectChannel,
          shopId: this.selectStore,
          logisticId: this.selectCourierCompany,
          classId: this.selectClassificationType,
          price: this.shopPrice,
          provinceIds: checkProvince
        };
        this.$axios.post(this.Global.saveStoreroomProvinceLogisticInfo, params).then((res) => {
          this.sucOrFail(res);
        });
      },

      // 删除渠道配省份物流信息
      delStoreroomProvinceLogisticByIds() {
        const params = this.msg;
        this.$axios.post(this.Global.delStoreroomProvinceLogisticByIds, params).then((res) => {
          this.sucOrFail(res);
        });
      },

      // 是否成功
      sucOrFail(res) {
        if (!res.data.errorMsg.length) {
          this.isMsg = true;
          this.isSuc = true;
          this.txtMsg = '操作成功';
        } else {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = res.data.errorMsg;
        }
      },

      // 提交按钮
      submitBtn() {
        if (this.showType === 'add') {
          this.saveStoreroomProvinceLogisticInfo();
        } else if (this.showType === 'del' || this.showType === 'batchDel') {
          this.delStoreroomProvinceLogisticByIds();
        }
      },

      // 取消按钮
      cancelBtn(type) {
        this.$emit('cancelbtn', {isShow: false, showType: this.showType, handleType: type});
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
        if (this.isSuc) {
          this.cancelBtn(true);
        }
      }
    },
    created() {
      if (this.showType === 'add') {
        this.getAllPXShopList();
        this.getAllStoreroomsList();
        this.getAllClassList();
        this.getAllLogisticList();
        this.getRegionProvinceList();
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../assets/css/home-view";

  .select_dialog_embed {
    .general_logistics_setup_embed_msg {
      &.w_percent70 {
        max-width: 965px;
      }

      .select_dialog_embed_box {
        width: 100%;

        .add {
          & > div {
            margin: 15px 20px;
          }

          .province_select {
            display: flex;
            align-items: center;

            .province_list {
              span {
                float: left;
              }

              ul {
                display: inline-block;

                li {
                  display: flex;
                  align-items: center;
                  float: left;
                  margin-right: 10px;

                  &:last-child {
                    margin-right: 0;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/home/goods-management/default-delivery-logistics/general-logistics-setup-embed-msg.vue